var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrowdark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8449 0.193363C7.97219 0.0694889 8.14409 0 8.32323 0C8.50237 0 8.67427 0.0694889 8.80156 0.193363C8.86441 0.254191 8.91432 0.326698 8.94839 0.406662C8.98246 0.486627 9 0.572452 9 0.659143C9 0.745834 8.98246 0.831659 8.94839 0.911623C8.91432 0.991588 8.86441 1.06409 8.80156 1.12492L4.97882 4.80694C4.85124 4.93064 4.67922 5 4.5 5C4.32078 5 4.14876 4.93064 4.02118 4.80694L0.198437 1.12492C0.135589 1.06409 0.0856788 0.991588 0.0516114 0.911623C0.017544 0.831659 0 0.745834 0 0.659143C0 0.572452 0.017544 0.486627 0.0516114 0.406662C0.0856788 0.326698 0.135589 0.254191 0.198437 0.193363C0.325732 0.0694889 0.497631 0 0.676769 0C0.855907 0 1.02781 0.0694889 1.1551 0.193363L4.50147 3.213L7.8449 0.193363Z",
    fill: "#1B1B1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowdark);
export default __webpack_public_path__ + "static/media/downArrowdark.1aaa08a21a4aadb6f7ea17fe3e9f5e58.svg";
export { ForwardRef as ReactComponent };